<div class="page traveler" style="padding-left:0;padding-right:0;">
  <div>
    <!--<div flex layout="row">-->
    @if (flowchartReady && chartViewModel) {
      <div class="flowchart-container">
        <flow-chart (contextMenu)="contextMenu($event)" [chartData]="chartViewModel">
        </flow-chart>
      </div>
    }
  <!--</div>	-->
</div>
<div [hidden]="formSize === 0"
  [ngClass]="{'side-min':formSize==30,'side-max':formSize==70}" class="flowcharts hideonprint side-panel">
  @for (selected_component of selected_components; track selected_component.data.id) {
    <div class="form-dialog">
      <h5 style="text-transform: uppercase;">
        <i (click)="expand()" [ngClass]="{'fa-arrow-right': expandSize==70, 'fa-arrow-left': expandSize==30}"
        class="fa" style="margin-right: 10px;"></i> Selected: {{selected_component.data.attributes?.base_type}}
      </h5>
    </div>
  }
</div>
<!--TODO:remove this, just a pain to keep adding and removing while I'm working on it on and off!!-->
@if (current_user && current_user.name==='Jules') {
  <button (click)="enableContext=!enableContext"
    class="context-button">Context {{enableContext}}
  </button>
}

<div [ngStyle]="{'display':menuVisible? 'block':'none'}" class="flowchart-context-menu">
  <ul class="menu-options">
    <!--Edit processes, streams and equipment-->
    @if (selected_components[0]?.data.attributes?.base_type==='process' || selected_components[0]?.data.attributes?.base_type==='stream'
      || selected_components[0]?.data.attributes?.base_type==='equipment') {
      <li (click)="editSelected(null, null)"
        class="menu-option">Edit
      </li>
    }
    <!--Edit custom chart-->
    @if (selected_components[0]?.data.type==='custom_chart') {
      <li (click)="editSelectedCustomChart(selected_components[0])"
        class="menu-option">Edit Custom Chart
      </li>
    }
    <!--Edit parent process of an image-->
    @if (selected_components[0]?.data.type==='image' && selected_components[0]?.parent_component) {
      <li (click)="selected_components[0]?.parent_component.select(); editSelected(null, null)"
        class="menu-option">Edit Process
      </li>
    }
    <!--Edit image-->
    @if (selected_components[0]?.data.type==='image') {
      <li (click)="editSelectedImage(selected_components[0])"
        class="menu-option">Edit Image
      </li>
    }
    <!--Edit context tile (allow editing of existing old context tiles)-->
    @if (selected_components[0]?.type==='context') {
      <li (click)="editSelectedContext(selected_components[0])"
        class="menu-option">Edit Context
      </li>
    }
    <!--Edit series summary tile-->
    @if (selected_components[0]?.data.type==='series-summary') {
      <li (click)="editSelectedContext(selected_components[0])"
        class="menu-option">Edit Series Summary
      </li>
    }

    <!--New Process-->
    @if (selected_components[0]?.data.type==='process' && selected_components[0]?.is_parent) {
      <li (click)="newProcess()"
        class="menu-option">New Process
      </li>
    }
    <!--New Custom Chart-->
    @if (selected_components[0]?.data.type==='process' && selected_components[0]?.is_parent) {
      <li (click)="editCustomChart(null, null, true)"
        class="menu-option">New Custom Chart
      </li>
    }
    <!--New Image-->
    @if (selected_components[0]?.data.type==='process') {
      <li (click)="editImage(null, null, true, selected_components[0])"
        class="menu-option">New Image
      </li>
    }

    <!--New Series Summary Tile-->
    @if (selected_components[0]?.data.type==='process' && selected_components[0]?.is_parent) {
      <li (click)="editContext(null, null, true)"
        class="menu-option">New Series Summary
      </li>
    }

    <!--      New Connector-->
    @if (selected_components[0]?.data.type==='process') {
      <li (click)="addNewConnector()"
        class="menu-option">Add Connector
      </li>
    }
    <!--New Equipment-->
    @if (selected_components[0]?.data.type==='process' || selected_components[0]?.data.type==='stream') {
      <li (click)="toggleMenu('hide');addNewEquipment()"
        class="menu-option">Add Equipment
      </li>
    }
    <!--New Point-->
    @if (selected_components[0]?.data.type==='stream') {
      <li (click)="addPoint(selected_components[0])"
        class="menu-option">Add Point
      </li>
    }

    <!--Delete Process, Stream, Equipment, Connector, Point-->
    @if (selected_components[0]?.type!=='custom_chart' &&
      selected_components[0]?.type!=='context' && selected_components[0]?.data.type!=='image'
      && selected_components[0]?.data.type!=='series-summary' &&
      selected_components[0]?.is_parent !==true) {
      <li (click)="deleteSelected()"
        class="menu-option">Delete
      </li>
    }
    <!--Delete Custom Chart, Context, Image-->
    @if (['custom_chart', 'context', 'image'].includes(selected_components[0]?.type) ||
      ['custom_chart', 'context', 'image', 'series-summary'].includes(selected_components[0]?.data?.type)) {
      <li (click)="deleteSelected(selected_components[0])"
        class="menu-option">Delete
      </li>
    }
    @if (selected_components[0]?.data.type==='image' && selected_components[0]?.parent_component
      && selected_components[0]?.parent_component.is_parent !== true) {
      <li
        class="menu-option" style="cursor:default;padding:0;">
        <a (click)="toggleMenu('hide');"
          routerLink="{{'/view/flowchart/' + selected_components[0].parent_component.data.id }}">
          Zoom In To Process
        </a>
      </li>
    }
    @if (selected_components[0]?.data.type==='process' &&	selected_components[0]?.is_parent !== true) {
      <li
        class="menu-option" style="cursor:default;padding:0;">
        <a (click)="toggleMenu('hide');" routerLink="{{'/view/flowchart/' + selected_components[0].data.id }}">
          Zoom In
        </a>
      </li>
    }
    @if (selected_components[0]?.data.type==='process' &&
      selected_components[0]?.is_parent === true && selected_components[0]?.data.relationships.parent.data) {
      <li
        class="menu-option" style="cursor:default;padding:0;">
        <a (click)="toggleMenu('hide');"
          routerLink="{{'/view/flowchart/' + selected_components[0].data.relationships.parent.data.id }}">
          Zoom Out
        </a>
      </li>
    }
    <!--Links to other process pages-->
    @if (selected_components[0]?.data.type==='process') {
      <li
        class="menu-option" style="cursor:default;padding:0;">
        <a (click)="toggleMenu('hide');"  target="_blank"
          routerLink="{{'/view/edit_series/' + selected_components[0].data.id }}">
          Open Series Sheet
        </a>
      </li>
    }
    @if (selected_components[0]?.data.type==='process') {
      <li
        class="menu-option" style="cursor:default;padding:0;">
        <a (click)="toggleMenu('hide');" target="_blank"
          routerLink="{{'/view/edit_series_components/' + selected_components[0].data.id }}">
          Open Report Configuration
        </a>
      </li>
    }
    @if (selected_components[0]?.data.type==='process' && selected_components[0]?.pagelinks().length) {
      @for (page of selected_components[0].pagelinks(); track page.id) {
        <li
          class="menu-option" style="cursor:default;padding:0;">
          <a (click)="toggleMenu('hide');"
            [routerLink]="'/view/page_view/' + page.id">
            Link to {{page.title}}
          </a>
        </li>
      }
    }
  </ul>
</div>

</div>
